import React from 'react';

import styled from 'styled-components';

import { MOBILE_BREAKPOINT } from 'core/hooks';

export interface ActionButtonGroupProps {
  children: React.ReactNode;
  className?: string;
  gap?: 'small' | 'medium' | 'large';
  wrap?: boolean;
}

export const ActionButtonGroup: React.FC<ActionButtonGroupProps> = ({ children, className, gap = 'medium', wrap = true }) => {
  return (
    <StyledActionButtonGroup className={className} $gap={gap} $wrap={wrap}>
      {children}
    </StyledActionButtonGroup>
  );
};

const StyledActionButtonGroup = styled.div<{ $gap: string; $wrap: boolean }>`
  display: flex;
  ${({ $wrap }) => $wrap && 'flex-wrap: wrap;'}
  gap: ${({ theme, $gap }) => {
    switch ($gap) {
      case 'small':
        return theme.space.spacing10;
      case 'large':
        return theme.space.spacing20;
      default:
        return theme.space.spacing10;
    }
  }};
  margin-bottom: ${({ theme }) => theme.space.spacing10};

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    gap: ${({ theme }) => theme.space.spacing20};
    margin-bottom: ${({ theme }) => theme.space.spacing20};

    /* More compact buttons on mobile */
    & > * {
      flex: 1;
      min-width: 120px;
      font-size: 0.875rem;
      padding: 0.5rem 0.5rem;
    }
  }
`;

ActionButtonGroup.displayName = 'ActionButtonGroup';
